import { useLingui } from '@lingui/react';
import { useCompanyId } from '@startuptools/common/react-wrapper';
import { useIdentityQuery } from '../../../graphql/react-operations';
import { Identity } from '@startuptools/business-ui/identity/Identity';
import { type TableRowData } from './Transaction';
import { NumberFormat } from '@startuptools/ui/NumberFormat';
import { Box } from '@startuptools/ui/Box';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { RichUserText } from '@startuptools/ui/RichUserText';

export const TransactionRow = ({
  row,
  showAvatar,
  showShareRange,
  showComments,
  onRefetch,
}: {
  row: TableRowData;
  showAvatar: boolean;
  showShareRange: boolean;
  showComments: boolean;
  onRefetch: () => void;
}) => {
  const { i18n } = useLingui();

  const companyId = useCompanyId();

  const { data: buyerData } = useIdentityQuery({
    variables: {
      companyId,
      id: row.buyerIdentityId || '',
    },
    skip: !row.buyerIdentityId,
  });

  const { data: sellerData } = useIdentityQuery({
    variables: {
      companyId,
      id: row.sellerIdentityId || '',
    },
    skip: !row.sellerIdentityId,
  });

  return (
    <>
      <tr>
        <td>{row.date}</td>
        <td>{row.label}</td>
        <td>
          {buyerData?.identity && (
            <Identity identity={buyerData.identity} showAvatar={showAvatar} onChange={onRefetch} />
          )}
        </td>
        <td>
          {sellerData?.identity && (
            <Identity identity={sellerData.identity} showAvatar={showAvatar} onChange={onRefetch} />
          )}
        </td>
        {!row.shareClass.from ? (
          <td>{row.shareClass.to}</td>
        ) : (
          <td>
            <Box display="flex" alignItems="center" justifyContent="start">
              {row.shareClass.from}
              <ArrowForwardIcon style={{ fontSize: '12px' }} />
              {row.shareClass.to}
            </Box>
          </td>
        )}
        <td align="right">
          <NumberFormat maximumFractionDigits={0} locale={i18n.locale}>
            {row.numberOfShares}
          </NumberFormat>
        </td>
        {showShareRange && (
          <>
            <td align="right">
              <NumberFormat locale={i18n.locale} maximumFractionDigits={0}>
                {row.blockStart}
              </NumberFormat>
            </td>
            <td align="right">
              <NumberFormat locale={i18n.locale} maximumFractionDigits={0}>
                {row.blockStart}
              </NumberFormat>
            </td>
          </>
        )}
        <td align="right">
          <NumberFormat locale={i18n.locale} variant="currency" currency={row.currency}>
            {row.pricePerShare}
          </NumberFormat>
        </td>
      </tr>
      {showComments && row.comment && (
        <tr>
          <td colSpan={5}>
            <RichUserText>{row.comment}</RichUserText>
          </td>
        </tr>
      )}
    </>
  );
};
